import { ManageActivitiesComponent } from "./../../../home/manage-activities/manage-activities.component";
import {
  Component,
  OnInit,
  Inject,
  Output,
  EventEmitter,
  ViewChildren,
  ElementRef,
  ViewChild,
} from "@angular/core";
import {
  LocalService,
  SellerService,
  Errors,
  ManagerService,
  FileService,
} from "../../../core";
import { CONSTANTS, managerApi } from "../../../config";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { PopupMessageService } from "../../message/services/message.service";
import { ApprovaltrackerDialogComponent } from "src/app/home/manage-activities/approvaltracker-dialog/approvaltracker-dialog.component";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { DOCUMENT } from "@angular/common";
import * as XLSX from "xlsx";
import { CashpaymentService } from "src/app/core/services/cashpayment.service";

@Component({
  selector: "app-seller-rewards-dialog",
  templateUrl: "./seller-rewards-dialog.component.html",
  styleUrls: ["./seller-rewards-dialog.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class SellerRewardsDialogComponent implements OnInit {
  @Output() submitClicked = new EventEmitter<any>();
  userProfile: any;
  isStatic: any;
  content: any;
  searchData: string = "";
  searchResult: any;
  regionList: any[] = [];
  months = CONSTANTS.months;
  errors: Errors = { errors: {} };
  default =
    "Manage how your Seller individuals participate in this program by turning on/off features and functionalities.";
  uploadSubmitBtn: boolean = true;
  selectedCategory: any = "";
  uploadedDocmentName: any;
  uploadProgressFlag: boolean = false;
  uploadedResult: any = [];
  statusHistoryList: any;
  loadStatusHistroy: boolean = false;
  signatureName: any = "";
  @ViewChildren("fileInput") myFileInput: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sellerService: SellerService,
    private managerService: ManagerService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<SellerRewardsDialogComponent>,
    private popupMessageService: PopupMessageService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private cashPaymentService: CashpaymentService,
    private fileService: FileService
  ) {}

  ngOnInit() {
    this.isStatic = this.data ? this.data : null;
    this.userProfile = LocalService.get("userProfile");
    this.content = this.data ? this.data : this.default;
    this.searchResult = this.data ? this.data.message : this.default;
    this.searchData = this.searchResult
      ? this.searchResult.searchText
      : "Enter your Sales PO Number";
    if (this.isStatic.name == "finalizeChallengePopup") {
      this.selectedCategory =
        this.isStatic.catogoriesLIst.uploadFileCategoryList[0].value;
      this.regionList = this.generateRegionUploadList(
        this.isStatic.catogoriesLIst.uploadFileCategoryList,
        this.isStatic.data.regions,
        this.isStatic.countryGroupList,
        this.isStatic.data
      );
    }

    // if(this.isStatic.name=='fileDownload'){
    //  this.selectedCategory=this.isStatic.fileData[0].category;
    //  this.onChangeCategory(this.selectedCategory)
    // }
    if (
      this.isStatic.name == "uploadDocument" ||
      this.isStatic.name == "fileDownload"
    ) {
      if (this.isStatic.fileData.attachedFiles.length == 0) {
        this.selectedCategory =
          this.isStatic.catogoriesLIst.uploadFileCategoryList[0].value;
      } else {
        this.selectedCategory =
          this.isStatic.fileData.attachedFiles[0].category;
      }

      this.regionList = this.generateRegionUploadList(
        this.isStatic.catogoriesLIst.uploadFileCategoryList,
        this.isStatic.fileData.regions,
        this.isStatic.countryGroupList,
        this.isStatic.fileData
      );

      this.onChangeCategory(this.selectedCategory);
    }

    if (
      this.isStatic.name == "uploadCompletions" ||
      this.isStatic.name === "sellerCoursesInfo" ||
      this.isStatic.name === "bannerImgPreview" ||
      this.isStatic.name == "statusHistorybyPartnerLeader" ||
      this.isStatic.name === "paymentConfirmationPopup" ||
      this.isStatic.name === "showSuccessMsg"
    ) {
      this.loadCiscoStyles("client-cisco.css");
    }
    if (this.isStatic.name == "statusHistorybyPartnerLeader") {
      this.getStatusHistoryOfCashPayments();
    }
  }
  sellerNoRecorFound(value: any) {
    this.searchResult = "";
    const queryParam = {
      searchText: value.trim(),
      companyId: this.userProfile.company.id,
    };
    this.managerService.getpoSearchResult(queryParam).subscribe((data: any) => {
      if (data) {
        this.searchResult = data;
      }
    });
  }
  valuechange(newValue: any) {
    this.searchData = "";
  }
  // Formatting a date
  formatDate(date: any) {
    const formatDate = new Date(date.split("T")[0]);
    return `${
      this.months[formatDate.getMonth()]
    } ${formatDate.getDate()}, ${formatDate.getFullYear()}`;
  }

  setTime(date: any) {
    return new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      new Date(date).getDate()
    );
  }

  // Get the status of participant's courses
  getStatus(check: any, completedBy: any, creationDate: any, startDate: any) {
    const lang = localStorage.getItem("selectedLanguage");
    let value = "Open";
    if (lang == "Korean") {
      value = "열다";
    }
    if (lang == "Japanese") {
      value = "開いた";
    }
    const createdDate = this.setTime(creationDate.split("T")[0]);
    const startOn = this.setTime(startDate.split("T")[0]);
    const completeByDate = this.setTime(completedBy.split("T")[0]);
    const currentDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (!check && isExpired) {
      value = "Closed";
      if (lang == "Korean") {
        value = "닫은";
      }
      if (lang == "Japanese") {
        value = "閉まっている";
      }
    }
    if (creationOn && pending) {
      value = "Pending";
      if (lang == "Korean") {
        value = "대기 중";
      }
      if (lang == "Japanese") {
        value = "保留中";
      }
    }
    return value;
  }
  getArchitecture(architecture: any) {
    const lang = localStorage.getItem("selectedLanguage");
    if (lang == "Korean" || lang == "Japanese") {
      if (architecture == "Collaboration") {
        if (lang == "Korean") {
          architecture = "협동";
        }
        if (lang == "Japanese") {
          architecture = "コラボレーション";
        }
      }
      if (architecture == "Security") {
        if (lang == "Korean") {
          architecture = "보안";
        }
        if (lang == "Japanese") {
          architecture = "セキュリティ";
        }
      }
      if (architecture == "Data Center") {
        if (lang == "Korean") {
          architecture = "데이터 센터";
        }
        if (lang == "Japanese") {
          architecture = "データセンター";
        }
      }
      if (architecture == "Enterprise Network") {
        if (lang == "Korean") {
          architecture = "엔터프라이즈 네트워크";
        }
        if (lang == "Japanese") {
          architecture = "エンタープライズネットワーク";
        }
      }
      if (architecture == "Wireless and Mobility") {
        if (lang == "Korean") {
          architecture = "무선 및 이동성";
        }
        if (lang == "Japanese") {
          architecture = "ワイヤレスとモビリティ";
        }
      }
      if (architecture == "Software") {
        if (lang == "Korean") {
          architecture = "소프트웨어";
        }
        if (lang == "Japanese") {
          architecture = "ソフトウェア";
        }
      }
      if (architecture == "Internet of Things") {
        if (lang == "Korean") {
          architecture = "사물 인터넷";
        }
        if (lang == "Japanese") {
          architecture = "モノのインターネット";
        }
      }
      if (architecture == "Services") {
        if (lang == "Korean") {
          architecture = "서비스";
        }
        if (lang == "Japanese") {
          architecture = "サービス";
        }
      }
    }
    return architecture;
  }
  // Split the data
  splitData(value: any) {
    // const newData = String(value).split('.')[0];
    const parseValue = parseFloat(value);
    const newData = parseValue.toLocaleString();
    return newData.toString();
  }

  htmlProperty(html: any) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  // Split html link from the data
  parseHTML(value: any) {
    return value.split("<")[0];
  }

  // Parse link from data
  parseLink(value: any) {
    return value.match(/href='([^']*)/)[1];
  }

  // Open link for take class in new tab
  viewClass(link: any) {
    window.open(link, "_blank");
  }

  // Get link for courses
  takeClass(link: any) {
    this.sellerService.getCoursesTakeClass().subscribe(
      (data: any) => {
        window.open(link, "_blank");
      },
      (err: any) => {
        this.errors = err;
      }
    );
  }

  takeQuiz(url: any, quizid: any) {
    let finalUrl = url;
    window.open(finalUrl, "_self");
  }

  prizeDrawing(ticketData: any) {
    ticketData.disableAutoFlag = true;
    this.submitClicked.emit(ticketData);
  }
  // provide file download option for cisco admin
  downloadFile(data: any) {
    const fileWindow = window.open(data.data.url, "_blank");
    if (fileWindow) { fileWindow.focus(); }
  }

  getFile(eve: any, item: any) {
    item.data = eve.target.files[0];
    item.showUploadBtn = true;
    item.uploadSuccess = false;
    item.flag = false;
  }

  removeFile(item: any) {
    item.data = "";
    item.showUploadBtn = false;

    item.flag = true;
  }

  uploadFile(item: any) {
    item.isUploading = true;
    const uploadData = new FormData();
    uploadData.append("file-to-be-uploaded", item.data);
    let challengeId = item.id;
    let param =
      "?CustomChallengeId=" +
      challengeId +
      "&region=" +
      item.region +
      "&category=" +
      this.selectedCategory;

    if (item.countryGroupId) {
      param = param + "&countryGroupId=" + item.countryGroupId;
    }
    this.sellerService.uploadAttachedDocument(uploadData, param).subscribe(
      (data: any) => {
        if (data.message) {
          item.flag = true;
          item.showUploadBtn = false;
          item.uploadSuccess = true;
          item.uploadFailure = false;
          item.name = item.data.name;
          item.data = "";
          item.isUploading = false;
          if (this.isStatic.name === "finalizeChallengePopup") {
            if (this.selectedCategory == "TERMS_AND_CONDITIONS") {
              const uploadedTerms = this.regionList.filter(
                (x) => x.category === "TERMS_AND_CONDITIONS"
              );
              if (uploadedTerms.find((x) => x.flag == false)) {
                this.uploadSubmitBtn = true;
              } else {
                this.uploadSubmitBtn = false;
              }
            }
          }
        }
      },
      (error: any) => {
        this.uploadSubmitBtn = true;
        item.flag = false;
        item.showUploadBtn = true;
        item.uploadSuccess = false;
        item.uploadFailure = true;
        item.isUploading = false;
      }
    );
  }
  // Upload terms and conditions
  submitUploadTerms() {
    // this.dialogRef.close();
    this.uploadSubmitBtn = true;
    let challengeId =
      this.isStatic.name === "finalizeChallengePopup"
        ? this.isStatic.data.id
        : this.isStatic.fileData.id;
    let params: any =
      "id=" + challengeId + "&status=" + "PENDING_FINAL_APPROVAL";
    this.managerService.submitForApproval(params).subscribe(
      (data: any) => {
        if (data != "") {
          this.uploadSubmitBtn = false;
          this.popupMessageService.showSuccess(
            "Uploaded Terms and condition successfully",
            "success",
            "salesChallengeToggleForm"
          );
          this.dialogRef.close({ uploadTerms: true });
        }
      },
      (error: any) => {
        // console.log(error)
      }
    );
  }
  categoryList: any = [];
  onChangeCategory(val: any) {
    this.regionList.forEach((region: any) => {
      let matched = false;

      for (let attachedFile of this.isStatic.fileData.attachedFiles) {
        if (attachedFile.category !== region.category) {
          continue;
        }

        // First priority: Match by category AND countryGroup ID
        if (
          attachedFile.countryGroup &&
          attachedFile.countryGroup.id === region.countryGroupId
        ) {
          region.name = attachedFile.name;
          region.noAttachment = false;
          region.data = { url: attachedFile.url };
          matched = true;
          break; // Found the most specific match, no need to continue
        }

        // Second priority: Match by category + region
        // BUT only if region.countryGroupId is not set
        if (
          !matched &&
          !region.countryGroupId && // ✅ Important: only fallback if no CG defined
          attachedFile.region === region.region
        ) {
          region.name = attachedFile.name;
          region.noAttachment = false;
          region.data = { url: attachedFile.url };
          matched = true;
          // Do not break here, in case a better match comes later (optional)
        }
      }

      // If still not matched, set "File Not Found"
      if (!matched) {
        region.name = "File Not Found";
        region.noAttachment = true;
        region.data = null;
      }
    });
  }

  // resend approval link
  resendEmailApprovalSpinner: boolean = false;
  approvalType: any;
  resendApprovalLink(val: any) {
    this.approvalType = val.type;
    this.resendEmailApprovalSpinner = true;
    const dialogRef = this.dialog.open(ApprovaltrackerDialogComponent, {
      width: "514px",
      data: { name: "resendApprovalData", data: val },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        setTimeout(() => {
          this.resendEmailApprovalSpinner = false;
        }, 1000);

        this.dialogRef.close({ approvals: result });
      } else {
        this.resendEmailApprovalSpinner = false;
      }
    });
  }
  sendApprovalLink(type: any) {
    let approvaltype = type;
    let reqParam =
      "customChallengeId=" +
      this.isStatic.data.id +
      "&approvalType=" +
      approvaltype;
    this.sellerService.resendApprovalLink(reqParam).subscribe((data: any) => {
      this.dialogRef.close({ approvals: data });
      this.popupMessageService.showSuccess(
        "Approval Link sent successfully",
        "success"
      );
    });
    this.dialogRef.close();
  }
  //submit for approval from draft to pending for approval
  submitForApproval() {
    this.dialogRef.close({ flag: true });
  }
  OnClosePopup() {
    this.dialogRef.close({ uploadTerms: true });
  }
  onChangeTermsandCondition(item: any) {
    this.selectedCategory = item.value;
    // this.regionList=[];

    //item.value!='TERMS_AND_CONDITIONS'?this.uploadSubmitBtn=false:this.uploadSubmitBtn=true;
    if (this.isStatic.name === "finalizeChallengePopup") {
      let termsCategory = this.regionList.filter(
        (x) => x.category === "TERMS_AND_CONDITIONS"
      );
      if (termsCategory.find((x) => x.flag == false)) {
        this.uploadSubmitBtn = true;
      }
    }
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
  downloadAttachment(data: any) {
    const attachmentWindow = window.open(data.url, "_blank");
    if (attachmentWindow) { attachmentWindow.focus(); }
  }
  loadCiscoStyles(styleName: any) {
    const head = this.document.getElementsByTagName("head")[0];
    const styleLink = this.document.createElement("link");
    styleLink.rel = "stylesheet";
    styleLink.classList.add("cisco_styles");
    styleLink.href = styleName;
    head.appendChild(styleLink);
  }
  ngOnDestroy(): void {
    // let ciscoLinkElement = document.head.querySelector(`link[rel="stylesheet"].${'cisco_styles'}`);
    // if (ciscoLinkElement) {
    //   document.head.removeChild(ciscoLinkElement);
    // };
  }

  getUploadDoc(eve: any) {
    this.uploadedResult = [];
    this.uploadProgressFlag = true;
    if (this.dndFlag) {
      this.uploadedDocmentName = eve[0];
    } else {
      this.uploadedDocmentName = eve.target.files[0];
    }
    setTimeout(() => {
      this.uploadCompletions();
    }, 1000);
  }
  uploadCompletions() {
    const uploadData = new FormData();
    uploadData.append("excelFile", this.uploadedDocmentName);
    const param =
      "?activityChallengeId=" +
      this.isStatic.challengeData.id +
      "&youSure=true";
    this.sellerService.uploadCompletion(uploadData, param).subscribe((res: any) => {
      if (res) {
        this.uploadProgressFlag = true;
        this.uploadedResult.push(res);
      }
    });
  }
  formatBytes(bytes: any, decimals: any) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  files: any[] = [];
  dndFlag: boolean = false;
  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    this.dndFlag = true;
    this.getUploadDoc($event);
  }
  downloadExcelModalOpen = false;
  downloadExcelType = '';

  showDownloadExcelFormatDialog(): void {
    this.downloadExcelType = 'UPLOAD_COMPLETION';
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  downloadExcel(): void {
    let columnData: string[][] = [];
    if (this.downloadExcelType === 'BEGEOID') {
      columnData = [['BEGEOID']];
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      columnData = [['END CUSTOMER GLOBAL HQ ID']];
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      columnData = [['PRODUCT', 'TYPE', 'PAYOUT']];
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      columnData = [['PRODUCT']];
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      columnData = [['PRODUCT', 'TYPE']];
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      columnData = [['PRODUCT SKUS']];
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      columnData = [['PRODUCT FAMILIES']];
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      columnData = [['USER', 'TARGET']];
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      columnData = [['BEGEOID', 'TARGET']];
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      columnData = [['USERIDS']];
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      columnData = [['BEGEOIDS']];
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'Participation Challenge Completions Upload.xlsx';
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
  getStatusHistoryOfCashPayments() {
    this.loadStatusHistroy = true;
    let req =
      "companyId=" +
      this.userProfile.company.id +
      "&cashPaymentId=" +
      this.isStatic.content.cashPaymentId;
    this.cashPaymentService
      .getStatusHistoryOfConsolidatedCashpaymentData(req)
      .subscribe(
        (response: any) => {
          this.loadStatusHistroy = false;
          if (response) {
            this.statusHistoryList = response;
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
  confirmPayment() {
    let req = {
      companyId: this.userProfile.company.id,
      cashPaymentId: this.isStatic.content.cashPaymentId,
      proofOfPaymentSignature: this.signatureName,
    };

    this.cashPaymentService.submitProofOfPayment(req).subscribe(
      (response: any) => {
        if (response) {
          this.popupMessageService.showSuccess(response.msg, "success");
          this.dialogRef.close(true);
        }
      },
      (error: any) => {
        if (error.message) {
          this.popupMessageService.showError(error.message, "error");
        }
      }
    );
  }

  loading: string | null = null;

  generateFile(list: any) {
    this.loading = list.key;
    const id = list.id;

    let req = "customChallengeId=" + id + "&region=" + list.region;

    if (list.countryGroupId) {
      req = req + "&countryGroupId=" + list.countryGroupId;
    }

    let url = "";

    if (list.category === "TERMS_AND_CONDITIONS") {
      url = managerApi.generateTandConditionsFile + req;
    } else if (list.category === "ELIGIBLE_PRODUCT_LIST") {
      url = managerApi.generateEligProductsDocumentationAsDownloadable + req;
    }

    this.fileService.downloadFile(url).subscribe({
      next: () => {
        this.loading = null;
      },
      error: (err: any) => {
        console.error("Download failed", err);
        this.loading = null;
      },
    });
  }
  generateRegionUploadList(
    categories: any[],
    regions: string[],
    countryGroupList: any,
    data: { id: string; startDate: string }
  ): any[] {
    const regionList: any[] = [];
    const targetDate = new Date("2025-10-25");
    categories.forEach((category) => {
      regions.forEach((region) => {
        const normalizedDateStr = data.startDate.replace(/\+0000$/, "Z");
        const startDate = new Date(normalizedDateStr);

        const hasCountryGroups =
          startDate > targetDate &&
          Array.isArray(countryGroupList[region]) &&
          countryGroupList[region].length > 0;

        if (hasCountryGroups) {
          countryGroupList[region].forEach((countryGroup: any) => {
            regionList.push({
              key: region + countryGroup.id,
              id: data.id,
              region: region,
              countryGroupId: countryGroup.id,
              countryGroupName: countryGroup.name,
              category: category.value,
              data: "",
              flag: false,
              showUploadBtn: false,
            });
          });
        } else {
          regionList.push({
            key: region,
            id: data.id,
            region: region,
            category: category.value,
            data: "",
            flag: false,
            showUploadBtn: false,
            name: "", // Optional, if needed
          });
        }
      });
    });

    return regionList;
  }
}
